import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsSnowboardNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M17.964.782a3.99 3.99 0 00-5.544 1.961l-1.837 4.319a43.019 43.019 0 01-3.494 6.569l-2.527 3.893a3.989 3.989 0 107.017 3.732l1.826-4.3a43.161 43.161 0 013.495-6.565l2.539-3.915A3.99 3.99 0 0017.964.782zm.341 4.959l-2.539 3.915a44.356 44.356 0 00-3.6 6.777l-1.826 4.3a2.638 2.638 0 11-4.64-2.474l2.527-3.894a44.355 44.355 0 003.6-6.774l1.837-4.32a2.613 2.613 0 011.549-1.455c.284-.1.584-.152.885-.153a2.641 2.641 0 012.209 4.078z" />
        <path d="M9.361 14.427l.017-.03a.938.938 0 011.268-.388l.442.234a.937.937 0 01.387 1.268l-.016.03a.938.938 0 01-1.269.388l-.446-.237a.937.937 0 01-.387-1.267zm4.506-6.502h-.504a.938.938 0 00-.938.938v.035c0 .518.42.938.938.938h.504c.518 0 .938-.42.938-.938v-.035a.938.938 0 00-.938-.938z" />
      </g>
    </svg>
  )
);
SvgSportsSnowboardNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgSportsSnowboardNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsSnowboardNormalSmall;
